// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VKPLOzDjBHifn4b9jg81 {
  min-width: 42px;
  color: #fff !important;
  font-size: 12px;
  background: #37003C !important;
  border-radius: 12px !important;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./js/view/component/user-avatar/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,sBAAA;EACA,eAAA;EACA,8BAAA;EACA,8BAAA;EACA,eAAA;AACF","sourcesContent":[".username {\n  min-width: 42px;\n  color: #fff !important;\n  font-size: 12px;\n  background: #37003C !important;\n  border-radius: 12px !important;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"username": `VKPLOzDjBHifn4b9jg81`
};
export default ___CSS_LOADER_EXPORT___;
